import { city } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getCityList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(city.cityBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getCityObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${city.cityBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addCity(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(city.cityBase, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateCity(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${city.cityBase}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateCity(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${city.cityBase}${payload.id}/`, payload.data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
